
import React, { Component } from "react";
import { Form, Row, Col, Input, Select, Table, Button, DatePicker, message } from "antd";
import config from "projectRoot/config.json";
import Request from "srcDir/util/request";
import Breadcrumb from "srcDir/components/breadcrumb";
import Storage from "store2";
import { urlAppendQuery, saveAs } from "srcDir/util/tools";
import { listByCode } from "srcDir/util/codeMap";
import moment from "moment";

const { Option } = Select;
const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD HH:mm:ss";
const today = moment().hour("23").minute("59")
  .second("59")
  .valueOf();
function disabledDate (current) {
  if (current) {
    if (moment().format("YYYY-MM-DD") === current.format("YYYY-MM-DD")) {
      return false;
    }
    return current.valueOf() > today;
  }
  return false;
}

const columns = [
  {
    title: "姓名",
    dataIndex: "name"
  }, {
    title: "联系方式",
    dataIndex: "phone"
  }, {
    title: "性别",
    dataIndex: "sex",
    render: text => {
      if (text === "M") {
        return <span>男</span>;
      } else if (text === "F") {
        return <span>女</span>;
      }
      return <span />;
    }
  }, {
    title: "咨询类型",
    dataIndex: "type"
  }, {
    title: "开店预算(万元)",
    dataIndex: "money"
  }, {
    title: "所在地区",
    dataIndex: "address"
  }, {
    title: "留言详情",
    dataIndex: "message",
    width: 300
  }, {
    title: "来源",
    dataIndex: "domainName",
    width: 300
  }, {
    title: "留言时间",
    dataIndex: "createTime"
  }
];

class View extends Component {
  constructor (props) {
    super(props);
    this.state = {
      data: [],
      MESSAGE_TYPE: [],
      total: 0,
      loading: false,
      expAllBtnLoading: false,
      params: {
        current: 1,
        pageSize: 10
      }
    };
  }

  componentDidMount () {
    this.init();
    this.search();
  }

  init () {
    listByCode("MESSAGE_TYPE").then(MESSAGE_TYPE => {
      this.setState({
        MESSAGE_TYPE
      });
    });
  }
  search (params = {}) {
    params = { ...this.state.params, ...params };
    this.setState({
      loading: true,
      params
    });
    Request.GET(`${config.host}/message/manage/list`, {
      params
    }).then(res => {
      this.setState({
        loading: false
      });
      if (res.success) {
        this.setState({
          data: res.data.records,
          total: res.data.total
        });
      } else {
        message.error(res.msg);
      }
    });
  }

  handleSubmit (e) {
    e.preventDefault();
    this.props.form.validateFields((err, fields) => {
      if (!err) {
        if (fields.date.length === 2) {
          fields.startTime = `${fields.date[0].format(dateFormat)} 00:00:00`;
          fields.endTime = `${fields.date[1].format(dateFormat)} 23:59:59`;
        } else {
          fields.startTime = "";
          fields.endTime = "";
        }
        delete fields.date;
        this.search(fields);
      }
    });
  }

  startAllExport () {
    this.setState({
      expAllBtnLoading: true
    });
    setTimeout(() => {
      this.setState({
        expAllBtnLoading: false
      });
      this.props.form.validateFieldsAndScroll((err, fields) => {
        if (!err) {
          if (fields.date.length === 2) {
            fields.startTime = `${fields.date[0].format(dateFormat)} 00:00:00`;
            fields.endTime = `${fields.date[1].format(dateFormat)} 23:59:59`;
          } else {
            fields.startTime = "";
            fields.endTime = "";
          }
          delete fields.date;
          const Authorization = Storage.get("Authorization").replace("\"", "").replace("\"", "");
          console.log({ ...fields, access_token: Authorization });
          const url = urlAppendQuery(`${config.host}/message/manage/export`, { ...fields, access_token: Authorization });
          saveAs(url,"文件导出");
        }
      });
    }, 1000);
  }

  render () {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, total, params, MESSAGE_TYPE } = this.state;
    const formItemLayout = {
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 15,
      },
    };

    return (
      <div className="common-page">
        <Breadcrumb crumb={["留言管理"]} />
        <div>
          <div className="view-operation-bar" style={{ marginBottom: "24px" }}>
            <Form onSubmit={e => this.handleSubmit(e)}>
              <Row>
                <Col span={4}>
                  <FormItem {...formItemLayout} label="姓名" >
                    {
                      getFieldDecorator("name", {
                        initialValue: ""
                      })(
                        <Input />
                      )
                    }
                  </FormItem>
                </Col>
                <Col span={4}>
                  <FormItem {...formItemLayout} label="手机" >
                    {
                      getFieldDecorator("phone", {
                        initialValue: ""
                      })(
                        <Input />
                      )
                    }
                  </FormItem>
                </Col>
                <Col span={4}>
                  <FormItem {...formItemLayout} label="咨询类型" >
                    {
                      getFieldDecorator("type", {
                        initialValue: ""
                      })(
                        <Select>
                          <Option value="">全部</Option>
                          {
                            MESSAGE_TYPE.map(item => (
                              <Option key={item.value}>{item.name}</Option>
                            ))
                          }
                        </Select>
                      )
                    }
                  </FormItem>
                </Col>
                <Col span={8}>
                  <FormItem
                    style={{ display: "flex", alignItems: "center" }}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                    label="留言时间"
                  >
                    {getFieldDecorator("date", { initialValue: [] })(<RangePicker
                      showTime={{
                        defaultValue: [moment("00:00:00", "HH:mm:ss"), moment("23:59:59", "HH:mm:ss")]
                      }}
                      disabledDate={disabledDate}
                      format={dateFormat}
                    />)}
                  </FormItem>
                </Col>
                <Col span={4}>
                  <FormItem wrapperCol={{ span: 24 }} >
                    <Button htmlType="submit" type="primary" style={{ marginRight: "10px" }}>查询</Button>
                    <Button onClick={() => this.props.form.resetFields()} >清除</Button>
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="view-operation-bar" style={{ marginBottom: "24px" }}>
            <Button
              style={{ marginLeft: 10 }}
              icon="download"
              onClick={() => this.startAllExport()}
              loading={this.state.expAllBtnLoading}
              disabled={!this.state.data.length}
            >导出
            </Button>
          </div>
          <Table
            size="small"
            bordered
            rowKey="id"
            dataSource={data}
            columns={columns}
            loading={loading}
            pagination={{
              showTotal:(totals, range) => `总记录：${totals}条`,
              total: total,
              current: params.current,
              showSizeChanger: true,
              pageSize: params.pageSize,
              onChange: (current) => {
                this.search({ current });
              },
              onShowSizeChange: (current, pageSize) => {
                this.search({ current, pageSize });
              },
            }}
          />
        </div>
      </div>
    );
  }
}

export default Form.create()(View);



// WEBPACK FOOTER //
// ./src/pages/report/message/index.js